import { createState, useState } from '@hookstate/core'
import { useEffect } from 'react'
import { useGoogleLoadState, getMap } from '../../stores/GoogleMapState'
import { MapFilterIconsMap } from '../../stores/MapFiltersState'
import { iconPaths } from '../../types/icon-name-types'
import { Delay, GeojsonFeature } from '../../types/JourneyPlannerTypes'
import { clearMarkerCollection, createDataLayer, styleMultiLine } from './MarkerCollection'
import { FeatureMapMarker } from '../../types/features'
import { createFeatureMarker, getMarkerPosition } from '../../util/feature-markers'
import { toLatLngLiteralOrNull } from '../../util/geometry-utils'


const trafficUpdateDetailState = createState<GeojsonFeature<Delay> | null>(null)

export const useTrafficUpdateDetailState = () => {
  return useState(trafficUpdateDetailState)
}

let pointMarker: FeatureMapMarker
let dataLayer: google.maps.Data
let bounds: google.maps.LatLngBounds
let pointMarkerPos: google.maps.LatLngLiteral | null | undefined

export const useTrafficUpdateDetailMap = () => {
  const googleLoadState = useGoogleLoadState()
  const updateApi = trafficUpdateDetailState.get()

  useEffect(() => {
    const googleLoaded = googleLoadState.get()
    const map = getMap()

    clearMarkerCollection()

    if (googleLoaded && map && updateApi) {
      const iconName = MapFilterIconsMap[updateApi?.properties.type]
      const iconPath = iconName && iconPaths[iconName]

      if (updateApi.geometry.type === 'Point') {
        const position = toLatLngLiteralOrNull(updateApi.geometry.coordinates[1], updateApi.geometry.coordinates[0])
        if (position) {
          pointMarker = createFeatureMarker({
            map,
            position,
            iconUrl: iconPath || iconPaths['marker'],
          })
        }
      }
      pointMarkerPos = pointMarker ? getMarkerPosition(pointMarker) : undefined

      if (pointMarkerPos) {
        bounds = new google.maps.LatLngBounds()

        bounds.extend(pointMarkerPos)

        // Zoom map to fit markers with padding of 50:
        map.fitBounds(bounds, 50)
        map.setZoom(18)
      } else {
        const styleFn = (feature: google.maps.Data.Feature) => styleMultiLine(null, feature)

        const coords = updateApi.geometry.coordinates.flatMap((x: any) => x)

        const startPosition = new google.maps.LatLng({
          lng: coords?.[0][0],
          lat: coords?.[0][1],
        })
        const endPosition = new google.maps.LatLng({
          lng: coords?.[coords.length - 1][0],
          lat: coords?.[coords.length - 1][1],
        })

        bounds = new google.maps.LatLngBounds()

        bounds.extend(startPosition)
        bounds.extend(endPosition)

        if (!dataLayer) {
          dataLayer = createDataLayer(map, styleFn, () => {})
        }

        map.fitBounds(bounds, 20)

        dataLayer.addGeoJson(updateApi)
      }
    }
  }, [googleLoadState, updateApi])
}
